export enum Step {
  DateRange = 'date_range',
  RateInput = 'rate_input',
  Confirm = 'confirm',
  Processing = 'processing',
}

export type RateRange = {
  /** Start date in YYYY-MM-DD format */
  start_date: string
  /** End date in YYYY-MM-DD format, or null if ongoing */
  end_date: string | null
  /** API returns BigDecimal as string */
  min_payable_rate: number | string
  /** API returns BigDecimal as string */
  max_payable_rate: number | string
  rate_card_id: number
  shift_count: number
  /** ISO 4217 currency code (e.g. 'GBP', 'USD') */
  currency: string
  /** Current rate for pre-population - API returns BigDecimal as string */
  client_rate: number | string
}

export type RateUpdate = {
  start_date: string
  end_date: string | null
  client_rate: number
}

export type ModalState = {
  step: Step
  /** Start date in YYYY-MM-DD format */
  startDate: string
  /** End date in YYYY-MM-DD format, or null if not set */
  endDate: string | null
  rateRanges: RateRange[]
  /** Keyed by `${start_date}_${end_date}`, values are rate as string */
  rateUpdates: Record<string, string>
  loading: boolean
  error: string | null
}

export type BulkShiftRateUpdateModalProps = {
  isOpen: boolean
  onClose: () => void
  jobId: number
  onSuccess?: () => void
}

export type DateRangeStepProps = {
  startDate: string
  endDate: string | null
  onStartDateChange: (date: string) => void
  onEndDateChange: (date: string | null) => void
  onNext: () => void
  onCancel: () => void
  loading: boolean
}

export type RateInputStepProps = {
  rateRanges: RateRange[]
  rateUpdates: Record<string, string>
  onRateChange: (rangeKey: string, rate: string) => void
  onBack: () => void
  onNext: () => void
  onCancel: () => void
}

export type RateRangeInputProps = {
  startDate: string
  endDate: string | null
  shiftCount: number
  rateCardId: number
  minRate: number | string // API returns BigDecimal as string
  maxRate: number | string // API returns BigDecimal as string
  currency: string
  clientRate: number | string // API returns BigDecimal as string
  value: string
  onChange: (rate: string) => void
  error?: string
}

export type ConfirmStepProps = {
  rateRanges: RateRange[]
  rateUpdates: Record<string, string>
  onBack: () => void
  onConfirm: () => void
  onCancel: () => void
}
